export const query = (selector, root = document) => {
  if (!selector) {
    return null;
  }

  return root?.querySelector(selector) ?? null;
};

export const queryAll = (selector, root = document) =>
  Array.from(root?.querySelectorAll(selector) ?? []);
